export const comparison = `title: Lecture-Based vs Active Learning in Undergraduate STEM

---
subtitle: Traditional Lecture
subtitle: Active Learning
---
Students retain 10-20% of material from a standard 50-minute lecture. EEG studies show attention declining after 10-15 minutes. In a meta-analysis of 225 studies covering 29,300 students, average failure rates under traditional lecturing were 33.8%. (Freeman et al., PNAS, 2014)
The same meta-analysis found active learning — structured problem-solving, peer instruction, and in-class exercises — reduced failure rates to 21.8%, a relative improvement of 36%. Examination scores increased by 0.47 standard deviations, equivalent to moving a student from the 50th to the 68th percentile.
-->
`;
